import { filterNonAstNodes } from '../parser';
import { assert } from '../util/todo';
import { associativityMap, buildBinaryOp, buildPostfixOp, precedenceMap } from './op';
import { buildOperand } from './operand';
export const buildOperandExpr = (node) => {
    return {
        kind: 'operand-expr',
        parseNode: node,
        operand: buildOperand(node)
    };
};
export const buildExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    const operatorStack = [];
    const exprStack = [];
    for (const n of nodes) {
        if (n.kind === 'sub-expr') {
            const expr = buildSubExpr(n);
            exprStack.push(expr);
        }
        else {
            const o1 = buildBinaryOp(n);
            while (operatorStack.length !== 0) {
                const o2 = operatorStack.at(-1);
                const o1Prec = precedenceMap.get(o1.kind);
                const o2Prec = precedenceMap.get(o2.kind);
                const o1Assoc = associativityMap.get(o1.kind);
                const o2Assoc = associativityMap.get(o2.kind);
                if (o1Prec === o2Prec && o1Assoc === 'none' && o2Assoc === 'none') {
                    throw Error(`cannot chain operators \`${o1.kind}\` and \`${o2.kind}\``);
                }
                if ((o1Assoc !== 'right' && o1Prec === o2Prec) || o1Prec < o2Prec) {
                    operatorStack.pop();
                    const rExp = exprStack.pop();
                    const lExp = exprStack.pop();
                    exprStack.push({
                        kind: 'binary-expr',
                        parseNode: { kind: 'expr', nodes: [lExp.parseNode, o2.parseNode, rExp.parseNode] },
                        binaryOp: o2,
                        lOperand: lExp,
                        rOperand: rExp
                    });
                }
                else {
                    break;
                }
            }
            operatorStack.push(o1);
        }
    }
    while (operatorStack.length !== 0) {
        const op = operatorStack.pop();
        const rExp = exprStack.pop();
        const lExp = exprStack.pop();
        exprStack.push({
            kind: 'binary-expr',
            parseNode: { kind: 'expr', nodes: [lExp.parseNode, op.parseNode, rExp.parseNode] },
            binaryOp: op,
            lOperand: lExp,
            rOperand: rExp
        });
    }
    assert(exprStack.length === 1, 'leftover expressions in the stack');
    let result = exprStack.pop();
    if (result.kind !== 'operand-expr' && result.kind !== 'unary-expr' && result.kind !== 'binary-expr') {
        result = { kind: 'operand-expr', parseNode: result.parseNode, operand: result };
    }
    return result;
};
export const buildSubExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    const operand = buildOperand(nodes[0]);
    const ops = nodes.slice(1).map(buildPostfixOp);
    if (ops.length === 0) {
        return operand;
    }
    let expr = operand;
    // fold a list of ops into left-associative unary-exprs
    for (const op of ops) {
        expr = {
            kind: 'unary-expr',
            parseNode: { kind: 'expr', nodes: [expr.parseNode, op.parseNode] },
            operand: expr,
            op
        };
    }
    return expr;
};
//# sourceMappingURL=expr.js.map